<template>
<div>
    <assign-survey-by-role></assign-survey-by-role>
</div>
</template>
<script>
import AssignSurveyByRole from './AssignSurveyByRole'
export default {
  name: 'AssignSurvey',
  components: {
    AssignSurveyByRole
  },
  data () {
    return {

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SurveyGroup/AssignSurvey.vue